import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';

import DirectionsIcon from '@deliveroo/icon-set/react/Directions';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import UnstyledButton from '@deliveroo/consumer-component-library/components/UnstyledButton';

import { selectDirectionHelpAction } from '../../selectors/directionHelpAction';

import getSafe from '../../utils/getSafe';

const DirectionHelpActionModal = dynamic(import('../../components/DirectionHelpActionModal'), {
  ssr: false,
});

export class DirectionHelpActionModalContainer extends Component {
  state = {
    isOpen: false,
  };

  onOpen = () => {
    this.setState({
      isOpen: true,
    });
  };

  onClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    return (
      <Fragment>
        <UnstyledButton onClick={this.onOpen}>
          <Icon component={DirectionsIcon} color="teal" />
        </UnstyledButton>

        <DirectionHelpActionModal
          appElement={this.props.appElement}
          isOpen={this.state.isOpen}
          onOpen={this.onOpen}
          onClose={this.onClose}
          restaurantName={this.props.restaurantName}
          address={this.props.address}
          modalTitle={this.props.modalTitle}
          canUseAppleMaps={this.props.canUseAppleMaps}
        />
      </Fragment>
    );
  }
}

DirectionHelpActionModalContainer.defaultProps = {
  appElement: '#__next',
  canUseAppleMaps: false,
};

DirectionHelpActionModalContainer.propTypes = {
  appElement: PropTypes.string,
  restaurantName: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  modalTitle: PropTypes.string.isRequired,
  canUseAppleMaps: PropTypes.bool,
};

export const mapStateToProps = (state) => {
  const directionHelpAction = selectDirectionHelpAction(state);

  const canUseAppleMaps =
    typeof window !== 'undefined' &&
    Boolean(navigator) &&
    Boolean(navigator.platform) &&
    /MacIntel|iPad|iPhone|iPod/.test(navigator.platform);

  return {
    restaurantName: getSafe(() => directionHelpAction.restaurantName),
    address: getSafe(() => directionHelpAction.address),
    latitude: getSafe(() => directionHelpAction.latitude),
    longitude: getSafe(() => directionHelpAction.longitude),
    modalTitle: getSafe(() => directionHelpAction.modalTitle),
    canUseAppleMaps,
  };
};

export default connect(mapStateToProps)(DirectionHelpActionModalContainer);
